// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__RwOJU","inputWrap":"Table_inputWrap__1H5GZ","col":"Table_col__145ps","bmiTooltip":"Table_bmiTooltip__1jkL0"};